import { FunctionComponent, useEffect, useState } from 'react';
import type {
  TPaystackSubscription,
  TPaystackSubscriptionPaginated,
} from '../../../types/payment';
import moment from 'moment';
import { subscriptionsList } from '../../../services/payment';
import { useToggle } from '../../../hooks/useToggle';
import CommonTable, { type ColumnConfig } from '../../common/Table';
import { useSimplePagination } from '../../../hooks/useSimplePagination';
import { PAGINATION_PER_PAGE } from '../../../utils/constants';

const columns: ColumnConfig<TPaystackSubscription>[] = [
  {
    key: 'id',
    header: 'ID',
  },
  {
    key: 'customer',
    header: "Learner's Email",
    render: (item) => item.customer.email,
  },
  {
    key: 'plan',
    header: 'Plan Name',
    className: 'max-w-64 truncate',
    render: (item) => item.plan.name,
  },
  {
    key: 'plan',
    header: 'Plan Duration',
    render: (item) => item.plan.interval,
  },
  {
    key: 'amount',
    header: 'Amount',
    render: (item) => `${item.plan.currency} ${item.plan.amount / 100}`,
  },
  {
    key: 'start',
    header: 'Start Date',
    render: (item) => moment(item.start).format('ddd D/M/YYYY - HH:MM'),
  },
  {
    key: 'next_payment_date',
    header: 'Next Payment Date',
    render: (item) =>
      moment(item.next_payment_date).format('ddd D/M/YYYY - HH:MM'),
  },
  {
    key: 'status',
    header: 'Status',
  },
];

const SubscriptionsTable: FunctionComponent<{}> = () => {
  const [subscriptions, setSubscriptions] =
    useState<TPaystackSubscriptionPaginated>({
      data: [],
      meta: {
        total: 0,
        skipped: 0,
        perPage: 50,
        page: 1,
        pageCount: 1,
      },
    });
  const { state: isLoading, on: showLoader, off: hideLoader } = useToggle();
  const { currentPage, totalPages, onPageChange, setTotalPages } =
    useSimplePagination();

  const fetchEvents = async () => {
    if (isLoading) return;
    showLoader();
    const res = await subscriptionsList({
      params: {
        page: currentPage,
        perPage: PAGINATION_PER_PAGE,
      },
    }).finally(() => {
      hideLoader();
    });
    if (res.data) setSubscriptions(res);
    if (res.meta) setTotalPages(res.meta.total);
  };

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line
  }, [currentPage]);

  return (
    <CommonTable
      columns={columns}
      data={subscriptions.data}
      currentPage={currentPage}
      totalPages={totalPages}
      isLoading={isLoading}
      onPageChange={onPageChange}
      showPagination
    />
  );
};

export default SubscriptionsTable;
